import { css } from "@emotion/css";
import { Button, Callout, Snackbar } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import { useInlineStatusMutation } from "@octopusdeploy/octopus-react-client";
import type { Repository } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import Dialog from "~/components/Dialog/Dialog";
import { useDialogTrigger } from "~/components/Dialog/DialogTrigger";
import RequestFreeTrialDialog from "~/components/DialogLayout/RequestFreeTrialDialog";
import { RequestTrialLink } from "~/components/RequestTrialCallout/RequestTrialLink";
export interface RequestTrialCalloutProps {
    featureName: string;
    onRequestTrial: (repository: Repository) => Promise<void>;
    content: string;
    dialogTitle: string;
    variant?: "link" | "button";
}
export const RequestTrialCallout = ({ onRequestTrial: onRequestTrialProp, content, dialogTitle, featureName, variant = "link" }: RequestTrialCalloutProps) => {
    const [showSnackbar, setShowSnackbar] = React.useState(false);
    const { closeDialog, openDialog, isOpen: isDialogOpen } = useDialogTrigger();
    const onRequestTrialLinkClicked = async () => {
        openDialog();
    };
    const { error: errorRequestingTrial, execute: requestFreeTrial, isExecuting: isRequestingFreeTrial, } = useInlineStatusMutation({
        action: onRequestTrialProp,
        name: `request free trial ${featureName}`,
        afterComplete: async () => {
            closeDialog();
            setShowSnackbar(true);
        },
    });
    const renderTrigger = () => {
        if (variant === "button") {
            return <Button size="medium" importance="loud" onClick={onRequestTrialLinkClicked} label="Request Free Trial"/>;
        }
        return <RequestTrialLink onClick={onRequestTrialLinkClicked}/>;
    };
    return (<>
            <div className={styles.calloutContainer}>
                <Callout type={"upsell"} hideTitle={true}>
                    <div className={variant === "button" ? styles.buttonContent : styles.linkContent}>
                        <span>{content}</span>
                        {renderTrigger()}
                    </div>
                </Callout>
                <Dialog open={isDialogOpen}>
                    <RequestFreeTrialDialog errors={errorRequestingTrial ? [errorRequestingTrial] : undefined} busy={isRequestingFreeTrial} dialogTitle={dialogTitle} onRequestTrial={requestFreeTrial}/>
                </Dialog>
            </div>
            <Snackbar open={showSnackbar} autoHideDuration={8000} onClose={() => setShowSnackbar(false)} content={"Trial request sent. We'll email you shortly with the details."} textAlign={"center"} size={"small"}/>
        </>);
};
const styles = {
    calloutContainer: css({
        marginBottom: space[16],
    }),
    linkContent: css({
        display: "inline-flex",
        gap: space[4],
    }),
    buttonContent: css({
        display: "flex",
        flexDirection: "column",
        gap: space[16],
        alignItems: "flex-start",
    }),
};
